import {RewardPolicyEnum} from 'src/constants/RewardPolicyEnum';
import Localized from 'src/constants/AppStrings';
import {MoreWaysToEarnPolicyModel} from 'src/types/RewardsModel';
import AccountStore from 'src/stores/AccountStore';
import {useGlobalize} from 'src/i18n/hook/useGlobalize';

export function getRewardPolicyDescription(model: MoreWaysToEarnPolicyModel): string {
  switch (model.policy.policyType) {
    case RewardPolicyEnum.LOAD_WALLET_MIN_AMOUNT:
      return updateDescriptionWithAmount(
        model.policy.minLoadAmount,
        model.policy.policyType,
        model.currency,
        model.policyDescription
      );
    case RewardPolicyEnum.MIN_SPEND:
      return updateDescriptionWithAmount(
        model.policy.minimumSpendAmount,
        model.policy.policyType,
        model.currency,
        model.policyDescription,
      );
    case RewardPolicyEnum.ADD_CREDIT_CARD:
      return Localized.Labels.add_credit_card_to_wallet;
    case RewardPolicyEnum.ADD_BIRTHDAY:
      return Localized.Labels.add_birth_day_to_your_account;
    case RewardPolicyEnum.ADD_PHONE_NUMBER:
      return Localized.Labels.add_your_phone_number;
    case RewardPolicyEnum.APP_SURVEY:
      return Localized.Labels.fill_out_app_survey;
    case RewardPolicyEnum.AUTO_RELOAD:
      return Localized.Labels.activate_auto_reload;
    case RewardPolicyEnum.COME_BACK_SOON:
      return Localized.Labels.come_back_soon_bonus;
    case RewardPolicyEnum.PURCHASE_STREAK:
      return Localized.Labels.purchase_streak;
    default:
      return model.policyDescription;
  }
}

function updateDescriptionWithAmount(
  amount: number,
  type: RewardPolicyEnum,
  currency: string,
  policyDescription: string,
): string {

  const {formatCurrency} = useGlobalize();
  const currencyValue = formatCurrency(
    amount ?? 0,
    currency ?? AccountStore.getCurrency(),
    {
      maximumFractionDigits: 2,
      minimumFractionDigits: 0,
    },
  );

  switch (type) {
    case RewardPolicyEnum.LOAD_WALLET_MIN_AMOUNT:
      return Localized.Labels.load_wallet_with_$X_or_more.replace(
        '{0}',
        currencyValue,
      );
    case RewardPolicyEnum.MIN_SPEND:
      return Localized.Labels.spend_$X_or_more.replace('{0}', currencyValue);
    default:
      return policyDescription.replace('$X', currencyValue);
  }
}
